import { render, staticRenderFns } from "./TalentMarketingPhoto.vue?vue&type=template&id=3cb8e916"
import script from "./TalentMarketingPhoto.vue?vue&type=script&lang=js"
export * from "./TalentMarketingPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports